module.exports = __webpack_public_path__ + "static/media/nightBackground.7b0abe30.jpg";